import {
  PrimePoiApiRoot,
  PrimePoiApiPaths,
  MakeAuthHeader,
  SettingApi
} from "../../config/api";
import { SettingHierarchy } from "../../config/setting";
import axios from "../../../node_modules/axios/index";
import FollowUpSettings from "../../models/FollowUpSetting";
import ApiCommunicationError from "../../exceptions/ApiCommunicationError";

// initial state
const state = {
  loading: false,
  error: false,

  allowEditing: true,
  showAboutPage: true,
  showChangePasswordPage: true,
  showOutstandingMap: true,
  fullDetailsClosedByDefault: true,
  cardTileIsNameAndAddress: true,
  recordPhotos: true,
  allowNativeMediaForPhotos: true,
  allowAddtionalLeaks: true,
  allowAddingComments: true,
  allowEscalation: true,
  allowPausing: true,
  allowPDPGraphCycling: true,
  leaksAllowAssetLeakType: true,
  leaksAllowEquipmentUsed: true,
  leaksAllowGeolocationSelection: true,
  allowOutstandingMapControls: true,
  allowOutstandingMapControlPause: true,
  allowOutstandingMapControlLeaveSite: true,
  allowOutstandingMapControlLeakFound: true,
  allowOutstandingMapControlComplete: true,
  showConfidence: true,
  showRadiusConfidence: false,
  showGroup: true,
  showTimestamp: true,
  showMaxPipeLength: false,
  showMinPipeLength: false,
  showAvgPipeLength: true,
  showFilter: true,
  showNumberOfCorrelations: true,

  // setting object storage
  userSettings: null,
  roleSettings: null,
  globalSettings: null,
  groupSettings: {},
  useGroupSetting: false,
  setting: {},
};

const getters = {
  loading(state) {
    return state.loading;
  },
  setting(state) {
    return state.setting;
  },
  error(state) {
    return state.error;
  },
  allowEditing(state) {
    return state.allowEditing;
  },
  showAboutPage(state) {
    return state.showAboutPage;
  },
  showChangePasswordPage(state) {
    return state.showChangePasswordPage;
  },
  showOutstandingMap(state) {
    return state.showOutstandingMap;
  },
  fullDetailsClosedByDefault(state) {
    return state.fullDetailsClosedByDefault;
  },
  cardTileIsNameAndAddress(state) {
    return state.cardTileIsNameAndAddress;
  },
  recordPhotos(state) {
    return state.recordPhotos;
  },
  allowNativeMediaForPhotos(state) {
    return state.allowNativeMediaForPhotos;
  },
  allowAddtionalLeaks(state) {
    return state.allowAddtionalLeaks;
  },
  allowAddingComments(state) {
    return state.allowAddingComments;
  },
  allowEscalation(state) {
    return state.allowEscalation;
  },
  allowPausing(state) {
    return state.allowPausing;
  },
  allowPDPGraphCycling(state) {
    return state.allowPDPGraphCycling;
  },
  leaksAllowAssetLeakType(state) {
    return state.leaksAllowAssetLeakType;
  },
  leaksAllowEquipmentUsed(state) {
    return state.leaksAllowEquipmentUsed;
  },
  leaksAllowGeolocationSelection(state) {
    return state.leaksAllowGeolocationSelection;
  },
  allowOutstandingMapControls(state) {
    return state.allowOutstandingMapControls;
  },
  allowOutstandingMapControlPause(state) {
    return state.allowOutstandingMapControlPause;
  },
  allowOutstandingMapControlLeaveSite(state) {
    return state.allowOutstandingMapControlLeaveSite;
  },
  allowOutstandingMapControlLeakFound(state) {
    return state.allowOutstandingMapControlLeakFound;
  },
  allowOutstandingMapControlComplete(state) {
    return state.allowOutstandingMapControlComplete;
  },
  showConfidence(state) {
    return state.showConfidence;
  },
  showRadiusConfidence(state) {
    return state.showRadiusConfidence;
  },
  showGroup(state) {
    return state.showGroup;
  },
  showTimestamp(state) {
    return state.showTimestamp;
  },
  showMaxPipeLength(state) {
    return state.showMaxPipeLength;
  },
  showMinPipeLength(state) {
    return state.showMinPipeLength;
  },
  showAvgPipeLength(state) {
    return state.showAvgPipeLength;
  },
  showFilter(state) {
    return state.showFilter;
  },
  showNumberOfCorrelations(state) {
    return state.showNumberOfCorrelations;
  },
  userSettings(state) {
    return state.userSettings;
  },
  roleSettings(state) {
    return state.roleSettings;
  },
  globalSettings(state) {
    return state.globalSettings;
  },
  groupSettings(state) {
    return state.groupSettings;
  }
};

// actions
const actions = {
  getSetting({ rootGetters, commit }) {
    return new Promise(resolve => {
      var account = rootGetters["login/selectedAccount"].id;
      let options = {
        headers: MakeAuthHeader(rootGetters["login/settingApiToken"]),
        url: `${SettingApi}/FollowUpSettings?account=${account}`,
        method: "GET",
      };
      axios(options)
      .then(res => {
        commit("setSetting", res.data);
        resolve();
      })
      .catch(error => {
        console.warn(error);
        resolve(false);
      })
    })
  },
};

// mutations
const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  setSetting(state, payload) {
    state.setting = payload;
  },
  clearLoading(state) {
    state.loading = false;
  },
  setError(state, payload) {
    state.error = payload;
  },
  clearError(state) {
    state.error = false;
  },

  setAllSettings(state, payload) {
    state.allowEditing = payload.allowEditing;
    state.showAboutPage = payload.showAboutPage;
    state.showChangePasswordPage = payload.showChangePasswordPage;
    state.showOutstandingMap = payload.showOutstandingMap;
    state.fullDetailsClosedByDefault = payload.fullDetailsClosedByDefault;
    state.cardTileIsNameAndAddress = payload.cardTileIsNameAndAddress;
    state.recordPhotos = payload.recordPhotos;
    state.allowNativeMediaForPhotos = payload.allowNativeMediaForPhotos;
    state.allowAddtionalLeaks = payload.allowAddtionalLeaks;
    state.allowAddingComments = payload.allowAddingComments;
    state.allowEscalation = payload.allowEscalation;
    state.allowPausing = payload.allowPausing;
    state.allowPDPGraphCycling = payload.allowPDPGraphCycling;
    state.leaksAllowAssetLeakType = payload.leaksAllowAssetLeakType;
    state.leaksAllowEquipmentUsed = payload.leaksAllowEquipmentUsed;
    state.leaksAllowGeolocationSelection =
      payload.leaksAllowGeolocationSelection;
    state.allowOutstandingMapControls = payload.allowOutstandingMapControls;
    state.allowOutstandingMapControlPause =
      payload.allowOutstandingMapControlPause;
    state.allowOutstandingMapControlLeaveSite =
      payload.allowOutstandingMapControlLeaveSite;
    state.allowOutstandingMapControlLeakFound =
      payload.allowOutstandingMapControlLeakFound;
    state.allowOutstandingMapControlComplete =
      payload.allowOutstandingMapControlComplete;
    state.showConfidence = payload.showConfidence;
    state.showRadiusConfidence = payload.showRadiusConfidence;
    state.showGroup = payload.showGroup;
    state.showTimestamp = payload.showTimestamp;
    state.showMaxPipeLength = payload.showMaxPipeLength;
    state.showMinPipeLength = payload.showMinPipeLength;
    state.showAvgPipeLength = payload.showAvgPipeLength;
    state.showFilter = payload.showFilter;
    state.showNumberOfCorrelations = payload.showNumberOfCorrelations;
  },

  setAllowEditing(state, payload) {
    state.allowEditing = payload;
  },
  setShowAboutPage(state, payload) {
    state.showAboutPage = payload;
  },
  setShowChangePasswordPage(state, payload) {
    state.showChangePasswordPage = payload;
  },
  setShowOutstandingMap(state, payload) {
    state.showOutstandingMap = payload;
  },
  setFullDetailsClosedByDefault(state, payload) {
    state.fullDetailsClosedByDefault = payload;
  },
  setCardTileIsNameAndAddress(state, payload) {
    state.cardTileIsNameAndAddress = payload;
  },
  setRecordPhotos(state, payload) {
    state.recordPhotos = payload;
  },
  setAllowNativeMediaForPhotos(state, payload) {
    state.allowNativeMediaForPhotos = payload;
  },
  setAllowAddtionalLeaks(state, payload) {
    state.allowAddtionalLeaks = payload;
  },
  setAllowAddingComments(state, payload) {
    state.allowAddingComments = payload;
  },
  setAllowEscalation(state, payload) {
    state.allowEscalation = payload;
  },
  setAllowPausing(state, payload) {
    state.allowPausing = payload;
  },
  setAllowPDPGraphCycling(state, payload) {
    state.allowPDPGraphCycling = payload;
  },
  setLeaksAllowAssetLeakType(state, payload) {
    state.leaksAllowAssetLeakType = payload;
  },
  setLeaksAllowEquipmentUsed(state, payload) {
    state.leaksAllowEquipmentUsed = payload;
  },
  setLeaksAllowGeolocationSelection(state, payload) {
    state.leaksAllowGeolocationSelection = payload;
  },
  setShowConfidence(state, payload) {
    state.showConfidence = payload;
  },
  setShowRadiusConfidence(state, payload) {
    state.showRadiusConfidence = payload;
  },
  setShowGroup(state, payload) {
    state.showGroup = payload;
  },
  setShowTimestamp(state, payload) {
    state.showTimestamp = payload;
  },
  setShowMaxPipeLength(state, payload) {
    state.showMaxPipeLength = payload;
  },
  setShowMinPipeLength(state, payload) {
    state.showMinPipeLength = payload;
  },
  setShowAvgPipeLength(state, payload) {
    state.showAvgPipeLength = payload;
  },
  setShowFilter(state, payload) {
    state.showFilter = payload;
  },
  setShowNumberOfCorrelations(state, payload) {
    state.showNumberOfCorrelations = payload;
  },

  setUserSettings(state, payload) {
    state.userSettings = payload;
  },
  clearUserSettings(state) {
    state.userSettings = null;
  },
  setRoleSettings(state, payload) {
    state.roleSettings = payload;
  },
  clearRoleSettings(state) {
    state.roleSettings = null;
  },
  setGlobalSettings(state, payload) {
    state.globalSettings = payload;
  },
  clearGlobalSettings(state) {
    state.globalSettings = null;
  },
  setGroupSettings(state, payload) {
    state.groupSettings = payload;
  },
  addGroupSetting(state, payload) {
    // payload is expected to be a setting object
    let newObj = {};
    newObj[payload.groupId] = payload;
    state.groupSettings = { ...state.groupSettings, ...newObj };
  },
  addEmptyGroupSetting(state, payload) {
    // payload in expected to just be the group id
    let newObj = {};
    newObj[payload] = null;
    state.groupSettings = { ...state.groupSettings, ...newObj };
  },
  clearGroupSettings(state) {
    state.groupSettings = {};
  },
  setUseGroupSetting(state, payload) {
    state.useGroupSetting = payload;
  },
  clearUseGroupSetting(state) {
    state.useGroupSetting = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
